import styled from "styled-components";
import Applications from "./applications";
import Case from "./case";
import { BoxWrapper, DashboardTitle, DashboardWrapper } from "./styles";
import FiBiUsersContent from "./FiBiUsersContent";

const Dashboard = () => {
  return (
    <Wrapper>
      <DashboardWrapper>
        <DashboardTitle>FiBi AI</DashboardTitle>
        <MiniWrapper>
          <FiBiUsersContent hideHeader />
        </MiniWrapper>
      </DashboardWrapper>
      <Applications />
      <Case />
    </Wrapper>
  );
};

export default Dashboard;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  height: 100%;
  padding: 20px 0;
`;

const MiniWrapper = styled(BoxWrapper)`
  flex-direction: column;
  min-height: auto;
`;
